
import Bottombar from './Bottombar'
import ViewBox from 'vux/src/components/view-box/index.vue'

export default {
name: 'MainLayout',
data () {
return {
}
},
components: {
Bottombar, ViewBox
}
}



// WEBPACK FOOTER //
// ./src/layout/MainLayout.vue